import { useTranslations } from 'use-intl'

import { cn } from '@/lib/utils'

export const CATEGORY_ICONS = {
  property: '/apps/property-security-icon.webp',
  people: '/apps/people-security-icon.webp',
} as const

function ProductCategory({
  category,
  variant = 'default',
  size = 'md',
  className,
  ...props
}: React.ComponentProps<'span'> & {
  category: keyof typeof CATEGORY_ICONS
  variant?: 'default' | 'outline' | 'highlight'
  size?: 'sm' | 'md'
}) {
  const t = useTranslations()
  const sm = size === 'sm'
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-xl border border-muted bg-transparent font-bold text-accent-foreground',
        sm ? 'gap-1.5 px-2 py-0.5 text-sm' : 'gap-2 px-2.5 py-1 text-lg',
        variant === 'outline' && 'border-white text-white',
        variant === 'highlight' && 'bg-app-highlight-faint border-muted',
        className,
      )}
      {...props}
    >
      <img
        src={CATEGORY_ICONS[category]}
        alt=""
        width={37}
        height={37}
        loading="lazy"
        decoding="async"
        className={cn(
          'shrink-0',
          sm ? 'size-5' : 'size-7',
          // force the colored PNG to pure white
          variant === 'outline' && 'brightness-0 invert',
        )}
      />
      {t(`nav.solutionsItems.${category}`)}
    </span>
  )
}

export { ProductCategory }
